export default function(/**@type {ApisauceInstance} */ api) {
    const getLeaderBoard = () => api.get("Home");

    return {
      leaderBoard: {
        getLeaderBoard, 
      },
    };
  }